import { render, staticRenderFns } from "./personalList.vue?vue&type=template&id=2e149750&scoped=true"
import script from "./personalList.vue?vue&type=script&lang=js"
export * from "./personalList.vue?vue&type=script&lang=js"
import style0 from "./personalList.vue?vue&type=style&index=0&id=2e149750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e149750",
  null
  
)

export default component.exports